import axios from "axios";

// Backend base URL is fully driven by build-time REACT_APP_BACKEND_URL.
// For the cPanel production build we set this to https://aydinlarglobalsigorta.com
// so every API call targets the customer's own PHP/MySQL backend. The Emergent
// preview build sets it to the preview URL. No hostname sniffing in shipped code.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, timeout: 45000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("asg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Initialize retry counter
  if (config.__retryCount === undefined) config.__retryCount = 0;
  return config;
});

const TRANSIENT_STATUS = new Set([404, 502, 503, 504]);
const MAX_RETRIES = 4;
const RETRY_DELAY_MS = 250;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const status = err?.response?.status;
    const isNetwork = !err.response && err.code !== "ECONNABORTED"; // no response = network / dns / connection reset
    const isTransient = isNetwork || TRANSIENT_STATUS.has(status);

    // Retry transient errors (backend restart, ingress cold-start, transient 404)
    // but ONLY for idempotent-safe requests. POST /auth/login is safe to retry —
    // the credentials will be re-verified server-side, no side effect.
    if (isTransient && cfg.__retryCount < MAX_RETRIES) {
      cfg.__retryCount += 1;
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS * cfg.__retryCount));
      return api(cfg);
    }

    if (status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/panel") && path !== "/panel") {
        localStorage.removeItem("asg_token");
        localStorage.removeItem("asg_user");
        window.location.href = "/panel";
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  // Translate common transient errors to friendly Turkish
  const status = e?.response?.status;
  if (!e?.response) return "Sunucuya ulaşılamıyor. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.";
  if (status === 404) return "Sunucu geçici olarak yanıt vermiyor. Birkaç saniye sonra tekrar deneyin.";
  if (status === 502 || status === 503 || status === 504) return "Sunucu meşgul. Lütfen tekrar deneyin.";
  if (status === 500) return "Sunucu hatası oluştu. Sorun devam ederse destek ile iletişime geçin.";
  return e?.message || "Bir hata oluştu";
}
